var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-place",class:{ 'radar-size': this.size === 'radar-size' }},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.currentTime))]),_c('div',{staticClass:"position-date-place"},[_c('div',{staticClass:"position"},[_vm._v(_vm._s(_vm.bridgeName))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.currentDate))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }